import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';

import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AppComponent } from './app.component';
import { FooterModule } from './shared/footer/footer.module';
import { FixedpluginModule } from './shared/fixedplugin/fixedplugin.module';
import { AppRoutes } from './app.routing';
import { CoreModule } from './core/core.module';
import { Globals } from './globals';
import { ComponentsModule } from './components/components.module';
import { DateFormatting } from './providers/date-formatting';
import { NumberFormatting } from './providers/number-formatting';
import { ObjectTransformations } from './providers/object-transformations';
import { TablesDotNet } from './providers/tables-dot-net';
import { DatePipe } from '@angular/common';
import { GlobalService } from 'app/services/global/global.service';
import { CommunicationService } from './services/communication/communication.service';
import { PrivacyPolicy } from './pages/public/privacy-policy/privacy-policy.component';
import { PrivacyPolicyWhiteLabel } from './pages/public/privacy-policy-whitelabel/privacy-policy-whitelabel.component';
import { PrivacyPolicyUsa } from './pages/public/privacy-policy-usa/privacy-policy-usa.component';
import { TermsAndConditionsUsa } from './pages/public/terms-and-conditions-usa/terms-and-conditions-usa.component';



//import { AngularFirestoreModule } from '@angular/fire/firestore';
import { PaymentComponent } from './pages/public/payment/payment.component';
import { PaymentCompletedComponent } from './pages/public/payment-completed/payment-completed.component';
//import { UserService } from './services/user/user.service';
import { ExportService } from './services/export/export.service';
import { ClientService } from './services/client/client.service';
import { LocationService } from './services/location/location.service';
import { TwilioService } from './services/twilio/twilio.service';
import { ResponseServiceService } from './services/response-service/response-service.firebase.service';
import { UploadService } from './services/upload/upload.service';
import { PromoCodeComponent } from './pages/public/promo-code/promo-code.component';
import { GroupShareComponent } from './pages/public/group-share-code/group-share-code.component';
import { IntercomComponent } from './pages/public/intercom/intercom.component';
import { IntercomModule } from 'ng-intercom';
import { CustomClientService } from './services/customClients/customClient.service';
import { PrivacyPolicyAfriform } from './pages/public/privacy-policy-afriform/privacy-policy-afriform.component';

import { FunctionDataService } from './services/function/function.data.service';
import { MatTableResponsiveModule } from './shared/mat-table-responsive/mat-table-responsive.module';
import { FunctionResponseServiceService } from './services/function/function.ResponseService.service'

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { AssetManagementService } from './services/asset-management/asset-management.service';
import { AssetManagementDialogComponent } from './pages/admin/admin-pages/asset-management/asset-management-dialog.component';
import { ConfirmationDialogComponent } from './pages/Common/confirmation-dialog.component';
import { MessageDialogComponent } from './pages/Common/message-dialog.component';
import { ResourceManagementService } from './services/resource-management/resource-management.service';
import { AdminDashboardJourneyManagementAssignmentDialogComponent } from './pages/admin/admin-pages/dashboard/admin-dashboard-journey-management-assignment-dialog.component';
import { ClientManagementService } from './services/client-management/client-management.service';
import { LinkPassengerComponent } from './pages/Common/link-passenger-dialog.component';
import { BookingManagementService } from './services/booking-management/booking-management.service';
import { AdminDashboardJourneyOverviewDialogComponent } from './pages/admin/admin-pages/dashboard/admin-dashboard-journey-overview-dialog.component';
import { RequestManagementDialogComponent } from './pages/admin/admin-pages/journey-management/request-management-dialog.component';
import { UserManagementService } from './services/user-managment/user-management.service';
import { UserManagementDialogComponent } from './pages/provider/provider-pages/user-management/user-management-dialog.component';
import { timeStampDataService } from './services/function/function.timestamp.service';
import { ImageModalComponent } from '../app/pages/provider/provider-pages/response-service-action/response-service-action/image-modal/image-modal.component';
import { ResponseServiceActionsManagementService } from './services/response-service-actions-management/response-service-actions-management.service';
import { PassengerDialogComponent } from './pages/admin/admin-pages/journey-management/passenger-dialog.component';
import { TravelDialogComponent } from './pages/admin/admin-pages/journey-management/travel-dialog.component';
import { ServiceDialogComponent } from './pages/admin/admin-pages/journey-management/service-dialog.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { environment } from 'environments/environment';
import { MomentTimezonePickerModule } from 'moment-timezone-picker';

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatDividerModule,
    MatTableResponsiveModule,
  ]
})
export class MaterialModule { }

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes),
    //HttpModule,
    MaterialModule,
    GooglePlaceModule,
    AgmCoreModule.forRoot({
      apiKey: environment.firebase['PROJECT-ONE'].apiKey
    }),
    MomentTimezonePickerModule,
    HttpClientModule,
    FooterModule,
    FixedpluginModule,
    ComponentsModule,
    //AngularFirestoreModule,
    IntercomModule.forRoot({
      appId: 'dbdmmuo7', // from your Intercom config
      updateOnRouterChange: true // will automatically run `update` on router event changes. Default: `false`
    }),
    
    ReactiveFormsModule,
  ],
  declarations: [
    AppComponent,
    PrivacyPolicyWhiteLabel,
    PrivacyPolicyAfriform,
    PrivacyPolicyUsa,
    TermsAndConditionsUsa,
    PrivacyPolicy,
    PaymentComponent,
    IntercomComponent,
    PromoCodeComponent,
    GroupShareComponent,
    PaymentCompletedComponent,
    AssetManagementDialogComponent,
    ConfirmationDialogComponent,
    LinkPassengerComponent,
    MessageDialogComponent,
    AdminDashboardJourneyManagementAssignmentDialogComponent,
    AdminDashboardJourneyOverviewDialogComponent,
    RequestManagementDialogComponent,
    PassengerDialogComponent,
    TravelDialogComponent,
    ServiceDialogComponent,
    ImageModalComponent,
    UserManagementDialogComponent,
  ],
  providers: [
    DateFormatting,
    NumberFormatting,
    ObjectTransformations,
    Globals,
    TablesDotNet,
    DatePipe,
    UploadService,
    GlobalService,
    TwilioService,
    //UserService,
    ExportService,
    FunctionDataService,
    FunctionResponseServiceService,
    LocationService,
    ResponseServiceService,
    ClientService,
    CommunicationService,
    CustomClientService,
    AssetManagementService,
    BookingManagementService,
    ResourceManagementService,
    ClientManagementService,
    UserManagementService,
    ResponseServiceActionsManagementService,
    GoogleMapsAPIWrapper,
    timeStampDataService,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
